import React from 'react';

export const NewTabLink = ({ href, children }) => {
  return (
    <a
      href={href}
      // Open the link in a new page
      target="_blank"
      // Add noopener and noreferrer for security reasons
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};
